// Co zalogowany klient już ma (kupione osobno lub w pakiecie) — żeby zamiast „Dodaj do koszyka” pokazać „Otwórz”.
// Jedno zapytanie /customer/library na całą stronę; odświeżane po zalogowaniu, wylogowaniu i zakupie (zdarzenie „dl-owned-refresh”).
import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;      // Map: id produktu -> { link, format, title }
let pending = null;
const listeners = new Set();

function load() {
  const token = (() => { try { return localStorage.getItem("dl_customer_token") || ""; } catch { return ""; } })();
  if (!token) { cache = new Map(); listeners.forEach((f) => f(cache)); return Promise.resolve(cache); }
  if (!pending) {
    pending = api.get("/customer/library", { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => new Map((data.items || []).map((i) => [i.id, { link: i.link, format: i.format, title: i.title, coming: i.coming_soon }])))
      .catch(() => new Map())
      .then((m) => { cache = m; pending = null; listeners.forEach((f) => f(cache)); return m; });
  }
  return pending;
}

if (typeof window !== "undefined") window.addEventListener("dl-owned-refresh", () => { cache = null; load(); });

export function refreshOwned() { window.dispatchEvent(new Event("dl-owned-refresh")); }

// gdzie „Otwórz” prowadzi: aplikacja i gra -> sama aplikacja; ebook, audiobook, pakiet -> biblioteka w koncie
export function openLink(item) {
  if (!item) return "/konto";
  return item.format === "aplikacja" && item.link && !item.link.startsWith("/produkt/") ? item.link : "/konto#biblioteka";
}

export function useOwned() {
  const [map, setMap] = useState(cache || new Map());
  useEffect(() => {
    listeners.add(setMap);
    if (!cache) load(); else setMap(cache);
    return () => listeners.delete(setMap);
  }, []);
  return map;
}
